export default {
    current: {
        phone: {
            description: '{userName} is already on a phone call.',
        },
        sms: {
            description: '{userName} is already composing an SMS.',
        },
        email: {
            description: '{userName} is already composing an email.',
        },
        video: {
            description: '{userName} is already in videoconference.',
        },
    },
    recent: {
        phone: {
            description: '{userName} called {timeAgo}.',
        },
        sms: {
            description: '{userName} sent an SMS {timeAgo}.',
        },
        email: {
            description: '{userName} sent an email {timeAgo}.',
        },
    },
};
